import React  from "react";
import { useParams } from 'react-router-dom';
import AccessGroupForm from "./components/AccessGroupForm";
import AccessGroupUserTable from "./access-group-users/components/AccessGroupUserTable";

const ViewAccessGroup = () => {
	const { groupId } = useParams();
    
	return (
	    <div>
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      		<AccessGroupForm recordId={groupId} mode="view"/>
				
				<AccessGroupUserTable parentId={groupId}/>
				
	      	</div>
	    </div>
    );
};

export default ViewAccessGroup;